import { ChevronRight } from '@material-ui/icons';
import classNames from 'classnames';
import React from 'react';
import { classnames } from 'tss-react/tools/classnames';
import { CheckMark } from '~/Components/Icons';
import { Button } from '~/UIKit';
import { IChecklistListItem } from '../checklistListItem.model';
import { CheckListItemListStyle } from './CheckListItemListStyle';

interface ICheckListItemListProps {
  checkListItems: IChecklistListItem[];
  checklistFooter?: IChecklistListItem;
  activeIndex: number;
}

export const CheckListItemList = ({
  checkListItems,
  activeIndex,
  checklistFooter,
}: ICheckListItemListProps) => {
  const { classes } = CheckListItemListStyle();
  const listSize = checkListItems.length;

  return (
    <>
      <div className={classes.checkListItemListContainer}>
        {checkListItems.map((item, index) => (
          <div
            key={item.index}
            className={classnames([
              {
                [classes.checkListItemListItem]: true,
                [classes.checkListItemListItemDisabled]: !item.active && item.deactivated,
                [classes.checkListItemListItemActive]: activeIndex > index && item.deactivated,
                [classes.checkListItemListItemChecked]: !item.deactivated,
                [classes.checkListItemListItemCurrentStep]: activeIndex - 1 === index,
              },
            ])}
          >
            <div className={classes.checkListItemListProgressWrapper}>
              <div
                className={classNames([
                  {
                    [classes.checkListItemListProgressLine]: true,
                    [classes.checkListItemListProgressLineActive]:
                      index !== 0 && activeIndex - 1 >= index,
                    [classes.checkListItemListProgressLineDeactivated]:
                      index !== 0 && activeIndex - 1 < index,
                  },
                ])}
              />
              <div className={classes.checkListItemListCircle}>
                {item.deactivated ? item.index : <CheckMark />}
              </div>
              <div
                className={classNames([
                  {
                    [classes.checkListItemListProgressLine]: true,
                    [classes.checkListItemListProgressLineActive]:
                      index !== listSize - 1 && activeIndex - 1 > index,
                    [classes.checkListItemListProgressLineDeactivated]:
                      index !== listSize - 1 && activeIndex - 1 <= index,
                  },
                ])}
              />
            </div>
            {item.icon}
            <Button variant="text" onClick={item.onClick} className={classes.checkListItemListLink}>
              <div className={classes.checkListItemListText}>
                <div className={classes.checkListItemListTitle}>{item.title}</div>
                <div>{item.description}</div>
              </div>
              <ChevronRight />
            </Button>
          </div>
        ))}
      </div>
      {checklistFooter && (
        <div className={classes.checkListItemListItemFooter}>
          <div className={classes.checkListItemExclamationMark}>!</div>
          <div className={classes.checkListItemListFooterItem}>
            <div className={classes.checkListItemListText}>
              <div className={classes.checkListItemListTitle}>{checklistFooter.title}</div>
              <div>{checklistFooter.description}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
